module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper"
  }, [_c('mall-header'), _vm._v(" "), (this.$route.meta.isKeepAlive === false) ? _c('div', {
    staticClass: "main-container"
  }, [_c('router-view')], 1) : _c('div', {
    staticClass: "main-container"
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68efef5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/layout/index.vue
// module id = 1626
// module chunks = 1